package com.trevorwiebe.timesheet.loads.presentation.driver

import com.trevorwiebe.timesheet.loads.domain.model.LoadAttachment
import kotlinx.datetime.LocalDate

/** One sticky-header section: a scheduled date (null = defensive "Unscheduled" bucket). */
data class DriverLoadGroup(
    val date: LocalDate?,
    val label: String,
    val loads: List<DriverLoadCardUi>,
)

/** A load with its stops already resolved to display text, ready to render as-is. */
data class DriverLoadCardUi(
    val id: String,
    val loadNumber: String,
    val orderNumber: String,
    val po: String,
    val commodity: String,
    val customerRequirements: String,
    val pickups: List<DriverStopUi>,
    val drops: List<DriverStopUi>,
    // Only the scans this driver uploaded.
    val documents: List<LoadAttachment> = emptyList(),
)

data class DriverStopUi(
    val name: String,
    val address: String,
    val cityState: String,
    val mapsLink: MapsLink?,
)

data class DriverLoadsState(
    val groupedLoads: List<DriverLoadGroup> = emptyList(),
    val isLoading: Boolean = true,
    val error: String? = null,
    // The load whose documents were last changed, and how that change is going.
    val documentLoadId: String? = null,
    val isSavingDocument: Boolean = false,
    val documentError: String? = null,
)
